import {EventEmitter, Injectable, Output} from '@angular/core';
import {Router} from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class SidebarServiceService {

  constructor(
    private router:Router
  ) {
    router.events.subscribe(val =>
      this.changeLocation(router.url)
    )
  }

  @Output() locationChanged :EventEmitter<string> = new EventEmitter<string>()
  @Output() width :EventEmitter<number> = new EventEmitter<number>()

  public changeLocation(location: string) {
    this.locationChanged.emit(location)
  }

  public changeWidth(width) {
    this.width.emit(width)
  }
}
